<template>
  <div>
    <div class="downloads">
      <div class="downloads__item" :class="{'downloads__item--loading': photos_loading}">
        <div class="downloads__left">
          <img src="@/assets/img/downloads-zip.svg" alt="Download">
          <div class="downloads__info">
            <button @click="onDownloadDocs" class="downloads__name">Client’s documents</button>
          </div>
        </div>
      </div>
    </div>
    <app-cells>
      <h2 class="title">
        <button
          @click="onCopyToClipboard(groupDetail.name)"
          type="button"
          class="client__copy"
        >
          {{ groupDetail.name }}&nbsp;
        </button>
        <button
          v-if="groupDetail.chief_guide"
          @click="onCopyToClipboard(`${groupDetail.chief_guide.first_name} ${groupDetail.chief_guide.last_name}`)"
          type="button"
          class="client__copy"
        >
          ({{ groupDetail.chief_guide.first_name }} {{ groupDetail.chief_guide.last_name }})
        </button>
      </h2>
    </app-cells>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default table-default--maxw"
    >
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #count="{ row, index }">{{ index }}</template>
      <template #full_name="{ row }">
        <div class="table-default__left">
          <button
            @click="onCopyToClipboard(row.client.full_name)"
            class="table-default__copy"
            :class="{'table-default__copy--disabled': !row.client.full_name}"
          >
            {{ row.client.full_name ? row.client.full_name : '-' }}
          </button>
        </div>
      </template>
      <template #passport="{ row }">
        <button
          @click="onCopyToClipboard(row.client.passport)"
          class="table-default__copy"
          :class="{'table-default__copy--disabled': !row.client.passport}"
        >
          {{ row.client.passport ? row.client.passport : '-' }}
        </button>
      </template>
      <template #citizenship="{ row }">
        <button
          @click="onCopyToClipboard(row.client.citizenship.name)"
          class="table-default__copy"
          :class="{'table-default__copy--disabled': !row.client.citizenship}"
        >
          {{ row.client.citizenship ? row.client.citizenship.name : '-' }}
        </button>
      </template>
      <template #gender="{ row }">
        <button
          @click="onCopyToClipboard(row.client.gender.name)"
          class="table-default__copy"
          :class="{'table-default__copy--disabled': !row.client.gender}"
        >
          {{ row.client.gender ? row.client.gender.name : '-' }}
        </button>
      </template>
      <template #age="{ row }">
        <button
          @click="onCopyToClipboard(row.age)"
          class="table-default__copy"
          :class="{'table-default__copy--disabled': !row.age}"
        >
          {{ row.age ? row.age : '-' }}
        </button>
      </template>
      <template #profile="{ row }">
        <div class="table-default__controls">
          <span
            class="table-default__activity table-default__activity--chief-guide table-default__activity--no-events"
            :class="{'table-default__activity--active': row.client.photo.photo}"
          />
          <span
            class="table-default__activity table-default__activity--adds table-default__activity--passport table-default__activity--no-events"
            :class="{
              'table-default__activity--active': row.passport_required,
              'table-default__activity--pin-green': row.passport_required && row.client.passport_copy,
              'table-default__activity--pin-red': row.passport_required && !row.client.passport_copy
            }"
          ></span>
          <span
            class="table-default__activity table-default__activity--adds table-default__activity--active table-default__activity--residence table-default__activity--no-events"
            :class="{
              'table-default__activity--resident': row.client.residence?.code === 'resident',
              'table-default__activity--foreigner': row.client.residence?.code === 'foreigner',
              'table-default__activity--ea': row.client.residence?.code === 'east_african',
              'table-default__activity--pin-green': row.residence_permit_required && row.client.residence_permit_copy,
              'table-default__activity--pin-red': row.residence_permit_required && !row.client.residence_permit_copy
            }"
          ></span>
        </div>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import { getClimbingGroupClientsForNP, getClimbingGroupDocs } from '@/http'
import { format, parse } from 'date-fns'

export default {
  name: 'ClimbingGroupsDetailNP',
  props: {
    groupDetail: {
      type: Object
    }
  },
  data() {
    return {
      table: {
        items: [],
        columns: ['count', 'full_name', 'passport', 'citizenship', 'gender', 'age', 'profile'],
        options: {
          headings: {
            'count': '#',
            'full_name': 'Full name',
            'passport': 'Passport',
            'citizenship': 'Nationality',
            'gender': 'Sex',
            'age': 'Age',
            'profile': 'Profile',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      photos_loading: false,
    }
  },
  created() {
    getClimbingGroupClientsForNP(this.$route.params.id)
      .then(response => {
        this.table.items = response.data
      })
  },
  methods: {
    onDownloadDocs() {
      this.photos_loading = true
      getClimbingGroupDocs(this.groupDetail.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.dateFormat(this.groupDetail.tour_start)} ${this.groupDetail.name} - Clients documents.zip`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.photos_loading = false
        })
    },
    onCopyToClipboard(string) {
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
  }
}
</script>

<style lang="sass" scoped>
.client__copy
  color: $color-text-base
  font-size: 17px
  font-weight: 600
  transition: color 0.3s

  &:active
    color: $color-theme

  @media (hover: hover)
    &:hover,
    &:focus-visible
      color: $color-theme
</style>
